import { db } from '@/lib/firebase';
import { collection, addDoc, getDocs, getDoc, updateDoc, doc } from 'firebase/firestore';
import { companySchema, insertCompanySchema, type Company, type InsertCompany } from '@/lib/schema';

export const getCompanies = async () => {
  const snapshot = await getDocs(collection(db, 'companies'));
  return snapshot.docs.map(d => {
    const data = d.data();
    return companySchema.parse({
      id: d.id,
      ...data,
      createdAt: data.createdAt.toDate(),
      updatedAt: data.updatedAt.toDate()
    });
  }) as Company[];
};

export const getCompany = async (id: string) => {
  const companyDoc = await getDoc(doc(db, 'companies', id));
  if (!companyDoc.exists()) return null;
  const data = companyDoc.data();
  return companySchema.parse({
    id: companyDoc.id,
    ...data,
    createdAt: data.createdAt.toDate(),
    updatedAt: data.updatedAt.toDate()
  }) as Company;
};

export const createCompany = async (data: InsertCompany) => {
  const parsed = insertCompanySchema.parse(data);
  const ref = await addDoc(collection(db, 'companies'), { ...parsed, createdAt: new Date(), updatedAt: new Date() });
  return getCompany(ref.id);
};

export const updateCompany = async (id: string, updates: Partial<Company>) => {
  await updateDoc(doc(db, 'companies', id), { ...updates, updatedAt: new Date() });
  return getCompany(id);
};
